"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stream = stream;
exports.streamFromText = streamFromText;
const axios_1 = require("axios");
const firebase_1 = __importDefault(require("../auth/firebase"));
const cache_1 = __importDefault(require("../helper/cache"));
const application_host_1 = require("../common/application-host");
const error_1 = require("../common/error");
function stream(endpoint, payload, filesOrHandler, onStreamOrAbortController, abortControllerOrOnAbort, onAbortParam) {
    return new Promise(async (resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const abortController = (onStreamOrAbortController instanceof AbortController
            ? onStreamOrAbortController
            : abortControllerOrOnAbort instanceof AbortController
                ? abortControllerOrOnAbort
                : undefined);
        const onStream = (typeof filesOrHandler === 'function'
            ? filesOrHandler
            : onStreamOrAbortController);
        const onAbort = (typeof abortControllerOrOnAbort === 'function'
            ? abortControllerOrOnAbort
            : onAbortParam);
        xhr.open('POST', `${application_host_1.ADD_API}${endpoint}`);
        xhr.onprogress = () => {
            onStream(xhr.response);
        };
        xhr.onload = () => {
            try {
                resolve(JSON.parse(xhr.response));
            }
            catch {
                resolve(xhr.response);
            }
        };
        xhr.onerror = () => {
            const error = new axios_1.AxiosError(xhr.statusText, xhr.status.toString());
            reject(new error_1.RequestError(error));
        };
        abortController?.signal.addEventListener('abort', () => {
            xhr.abort();
            onAbort?.();
            reject(new error_1.AbortedRequest());
        });
        try {
            const user = firebase_1.default.currentUser;
            if (user) {
                await user.getIdToken().then((token) => {
                    xhr.setRequestHeader("Authorization", `Bearer ${token}`);
                });
            }
            else {
                await cache_1.default.getItem(`appUser_${application_host_1.ENV_TYPE}`).then((cachedUser) => {
                    xhr.setRequestHeader("user", cachedUser.id);
                });
            }
            ;
        }
        catch (error) {
            reject(new error_1.AuthenticationError());
        }
        const resquestData = (typeof filesOrHandler === 'function' ? JSON.stringify(payload) : new FormData());
        if (resquestData instanceof FormData && typeof filesOrHandler !== 'function') {
            filesOrHandler.forEach((file) => {
                resquestData.append('file', file);
            });
            resquestData.append('payload', JSON.stringify(payload));
        }
        else {
            xhr.setRequestHeader("Content-Type", "application/json");
        }
        xhr.send(resquestData);
    });
}
function streamFromText(endpoint, texts, payload, onStream) {
    return new Promise(async (resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', endpoint);
        xhr.onprogress = () => {
            onStream(xhr.response);
        };
        xhr.onload = () => {
            try {
                resolve(JSON.parse(xhr.response));
            }
            catch {
                resolve(xhr.response);
            }
        };
        xhr.onerror = () => {
            const error = new axios_1.AxiosError(xhr.statusText, xhr.status.toString());
            reject(new error_1.RequestError(error));
        };
        try {
            const user = firebase_1.default.currentUser;
            if (user) {
                await user.getIdToken().then((token) => {
                    xhr.setRequestHeader("Authorization", `Bearer ${token}`);
                });
            }
            else {
                await cache_1.default.getItem(`appUser_${application_host_1.ENV_TYPE}`).then((cachedUser) => {
                    xhr.setRequestHeader("user", cachedUser.id);
                });
            }
            ;
        }
        catch (error) {
            reject(new error_1.AuthenticationError());
        }
        const requestData = new FormData();
        requestData.append('payload', JSON.stringify({
            ...payload,
            texts,
        }));
        xhr.send(requestData);
    });
}
;
